<!-- TelaExtraiDadosUsuario.svelte -->
<script>
  import ExtraiDadosBasico from "../../Componentes/ExtracaoDados/ExtraiDadosBasico.svelte";
  import ExibeItem from "../../Classes/exibeItem.js";
  import BotaoInserir from "../../componentes_basicos/BotaoInserir.svelte";
  import Pesquisa from "../../Componentes/ExtracaoDados/Pesquisa.svelte";
  import { DadosLogin } from "../../Classes/Stores";
  import Constantes from "../../Classes/Constantes";
  import TelasAcessoNaoAutorizado from "./TelasAcessoNaoAutorizado.svelte";

  let id_assessoria = $DadosLogin.id_assessoria;
  export let id_usuario;
  // Define as propriedades para o componente ExtraiDadosBasico
  let termo_pesquisa = "";
  let extraiDadosBasico;
  export let podeDeletar;
  export let tabela;
  const api = "consultas.php";
  const parametros = {
    query_code: "consulta_historico_teste",
    termo_pesquisa: termo_pesquisa,
    campos_pesquisaveis: ["tipo_teste", "resultado","data_teste"],
    id_assessoria: id_assessoria,
    id_usuario: id_usuario,
    
  };
  const celulas = [
    new ExibeItem("Data", "data_teste"),
    new ExibeItem("Tipo de teste", "tipo_teste"),
    new ExibeItem("Resultado", "resultado"),



  ];

  //só precisa configurar acima disto
</script>

<div class="centralizar">
 
    <Pesquisa {parametros} bind:value={termo_pesquisa} {extraiDadosBasico}
      ><ExtraiDadosBasico
        {podeDeletar}
        {tabela}
        {api}
        {parametros}
        {celulas}
        bind:this={extraiDadosBasico}
        
      />
    </Pesquisa>

  
</div>

<style>

</style>
